export const STATUS_CONFIG = {
  AT_PMO:       { label: "· AT PMO",       bg: "rgba(40,179,180,0.12)",  color: "#28B3B4", border: "rgba(40,179,180,0.3)" },
  AT_SCG:       { label: "· AT SCG",       bg: "rgba(214,223,39,0.12)",  color: "#D6DF27", border: "rgba(214,223,39,0.3)" },
  ACTIVE:       { label: "· ACTIVE",       bg: "rgba(40,179,180,0.12)",  color: "#28B3B4", border: "rgba(40,179,180,0.3)" },
  REJECTED:     { label: "· REJECTED",     bg: "rgba(200,64,64,0.12)",   color: "#c84040", border: "rgba(200,64,64,0.3)"  },
  MOVE_PENDING: { label: "· MOVE PENDING", bg: "rgba(200,138,58,0.12)",  color: "#c88a3a", border: "rgba(200,138,58,0.3)" },
};

export const LEFT_BORDER = {
  AT_PMO:       "#28B3B4",
  AT_SCG:       "#D6DF27",
  ACTIVE:       "#28B3B4",
  REJECTED:     "#c84040",
  MOVE_PENDING: "#c88a3a",
};

export const GATE_CONFIG = {
  PMO: { label: "PMO Gate", color: "#28B3B4" },
  SCG: { label: "SCG Gate", color: "#D6DF27" },
};

export const DECISION_CONFIG = {
  APPROVED: { label: "APPROVED", color: "#28B3B4", bg: "rgba(40,179,180,0.1)",  border: "rgba(40,179,180,0.3)" },
  REJECTED: { label: "REJECTED", color: "#c84040", bg: "rgba(200,64,64,0.1)",   border: "rgba(200,64,64,0.3)"  },
  PENDING:  { label: "PENDING",  color: "#D6DF27", bg: "rgba(214,223,39,0.1)",  border: "rgba(214,223,39,0.3)" },
};

export const PARENT_STATUS_MAP = {
  SUBMITTED:    { label: "Pending PMO", color: "#D6DF27" },
  PMO_APPROVED: { label: "At SCG",      color: "#28B3B4" },
  ACTIVE:       { label: "Approved",    color: "#4a9960" },
  REJECTED:     { label: "Rejected",    color: "#c84040" },
};

export const AVATAR_COLORS = ["#28B3B4", "#D6DF27", "#4a9960", "#7a5abd", "#c88a3a"];

export const getInitials = (name, fallback) => {
  if (fallback) return fallback;
  if (!name)    return "??";
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

export const getAvatarColor = (name) => {
  if (!name) return AVATAR_COLORS[0];
  const code = (name.charCodeAt(0) || 0) + (name.charCodeAt(1) || 0);
  return AVATAR_COLORS[code % AVATAR_COLORS.length];
};

export const formatDateRange = (start, end) => {
  const fmt = (d) =>
    d ? new Date(d).toLocaleDateString("en-GB", { month: "short", year: "2-digit" }) : "—";
  return `${fmt(start)} – ${fmt(end)}`;
};

export const fmt = (d) =>
  d ? new Date(d).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "2-digit" }) : "—";